import { translate, useLocale } from "../localization";
import { useEffect } from "react";
import "./Sessions.scss";
import "./Dashboard.scss";
import { usePageMetadata } from "../context/PageMetadataContext";
import { useAnalytics } from "../context/AnalyticsContext";
import Filters from "../components/dashboard/Filters";
import SessionListItem from "../components/dashboard/SessionListItem";
import GridHeader from "../components/dashboard/GridHeader";
import SortToggleButton from "../components/SortToggleButton";
import { getPreferredSessionIdentifier } from "../utility/sessionIdentifiers";
import AnalyticsModeNotice from "../components/dashboard/AnalyticsModeNotice";

const SESSION_POLL_INTERVAL_MS = 30 * 1000;

const Sessions = () => {
  const locale = useLocale();
  const { setTitle, setShowTitleInHeader } = usePageMetadata();
  const { sessions, sortSessions, activeSessionSort, refreshAnalytics, analyticsError } = useAnalytics();

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowTitleInHeader(true);
    setTitle(translate("Student sessions"));
    refreshAnalytics().catch(() => {});
  }, [refreshAnalytics, setShowTitleInHeader, setTitle, locale]);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      if (document.visibilityState !== "visible") return;
      refreshAnalytics({ force: true }).catch(() => {});
    }, SESSION_POLL_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [refreshAnalytics]);

  return (
    <div className="dashboard sessions">
      <div className="content">
        <AnalyticsModeNotice error={analyticsError} />
        <Filters variant="compact" />
        <div className="sessions-table dashboard-data-table">
          {sessions && (
            <GridHeader>
              <div className="grid-column narrow">
                <SortToggleButton
                  attribute="startTime"
                  sortFunction={sortSessions}
                  activeSort={activeSessionSort}
                />{translate("Date")}</div>
              <div className="grid-column slim">{translate("Name")}</div>
              <div className="grid-column narrow">
                <SortToggleButton
                  attribute="meanScore"
                  sortFunction={sortSessions}
                  activeSort={activeSessionSort}
                />{translate("Score")}</div>
              <div className="grid-column narrow">
                <SortToggleButton
                  attribute="responseCount"
                  sortFunction={sortSessions}
                  activeSort={activeSessionSort}
                />{translate("Insights")}</div>
              <div className="grid-column slim">
                <SortToggleButton
                  attribute="secondsSpent"
                  sortFunction={sortSessions}
                  activeSort={activeSessionSort}
                />{translate("Time spent")}</div>
              <div className="grid-column narrow session-actions-column"></div>
            </GridHeader>
          )}
          <div className="sessions-list app-row-list">
            {sessions &&
              sessions.map((session) => (
                <SessionListItem
                  key={
                    getPreferredSessionIdentifier(session) ||
                    `${session.startTime || "session"}-${session.responseCount || 0}`
                  }
                  session={session}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sessions;
